import ReactDOM from 'react-dom';
import App from './App';
import './i18n';
import { BrowserRouter, HashRouter, MemoryRouter } from 'react-router-dom';

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root')
);
